<!--<app-maser-page-header></app-maser-page-header>-->
<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style ">
            <li class="breadcrumb-item">
              <h4 class="page-title">Product</h4>
            </li>

          </ul>
        </div>
      </div>
    </div>
    <!-- <app-maser-page-header></app-maser-page-header> -->
    <div class="row">
      <div class="col" *ngIf="!productService.is_display_product_register_component">

        <button mat-fab color="primary" (click)="registerProduct()">
          <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon>
        </button>
        <table mat-table [dataSource]="dataSource" style="width: 100%;    margin-top: 18px;" matSort class="mat-elevation-z8">
          <!-- Position Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> ID</th>
            <td mat-cell *matCellDef="let element;let i = index"> {{i+1}}</td>
          </ng-container>

          <!-- code Column -->
          <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Code</th>
            <td mat-cell *matCellDef="let element"> {{element.code}}</td>
          </ng-container>

          <!-- quantity Column -->
          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Quantity</th>
            <td mat-cell *matCellDef="let element"> {{element.quantity}} {{element.unit_name}}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Name</th>
            <td mat-cell *matCellDef="let element">{{element.name}}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="short_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Short Name</th>
            <td mat-cell *matCellDef="let element">{{element.short_name}}</td>
          </ng-container>

          <!-- Mrp Column -->
          <ng-container matColumnDef="mrp">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Mrp</th>
            <td mat-cell *matCellDef="let element">{{element.mrp}} Rs.</td>
          </ng-container>

          <!-- Mrp Column -->
          <ng-container matColumnDef="base_price">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Base Price</th>
            <td mat-cell *matCellDef="let element">{{element.base_price}} Rs.</td>
          </ng-container>

          <!-- Mrp Column
           <ng-container matColumnDef="unit">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Unit</th>
              <td mat-cell *matCellDef="let element">{{element.unit_name}}</td>
            </ng-container> -->

          <!-- gst Column -->
          <ng-container matColumnDef="gst">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> GST %</th>
            <td mat-cell *matCellDef="let element">{{element.gst_percent}}</td>
          </ng-container>

          <!-- gst Column -->
          <ng-container matColumnDef="snf">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> SNF %</th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element.snf == 0">
                N/A
              </span>
              <span *ngIf="element.snf != 0">
                {{element.snf}}
              </span>
            </td>
          </ng-container>

          <!-- gst Column -->
          <ng-container matColumnDef="fat">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> FAT %</th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element.fat == 0">
                N/A
              </span>
              <span *ngIf="element.fat != 0">
                {{element.fat}}
              </span>
            </td>
          </ng-container>

          <!-- quantity Column -->
          <ng-container matColumnDef="product_group">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Product Group</th>
            <td mat-cell *matCellDef="let element"> {{element.group_name}}</td>
          </ng-container>




          <!-- edit Column -->
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Edit</th>
            <td mat-cell *matCellDef="let element">
              <mat-icon (click)="editProduct(element)">edit</mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

      <div class="col-8" *ngIf="productService.is_display_product_register_component">
        <div class="row">
          <div class="col"></div>
          <div class="col-1">
            <button mat-fab color="primary" (click)="hideProductRegister()">
              <i class="material-icons">
                clear
              </i>
            </button>
          </div>
        </div>
        <app-product-register></app-product-register>
      </div>
    </div>
  </div>
</section>
